/**
 * @file Opens the Plaid Link flow as soon as it is ready, given a link
 * token.
 */
import React, { useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import type { PlaidLinkOnExit } from "react-plaid-link";

type Props = {
  token: string;
  onExit: PlaidLinkOnExit;
  onSuccess: (publicToken: string) => unknown;
};

/**
 * Renders nothing and opens the Plaid Link flow as soon as the given
 * token is ready.
 */
const PlaidConnect = ({ token, onSuccess, onExit }: Props): JSX.Element => {
  const { open, ready } = usePlaidLink({
    token,
    onExit,
    /** Forwards the public token to the caller's success callback. */
    onSuccess: (publicToken) => onSuccess(publicToken),
  });

  useEffect(() => {
    if (!ready) {
      return;
    }

    open();
  }, [ ready, open ]);

  return (
    <></>
  );
};

export default PlaidConnect;
